const TrainingPlanReducer = (state = {}, action) => {
    switch (action.type) {
      case "TP_LISTVIEW":
        return Object.assign({}, state, {
          TP_ListView: action.data
        });
      case "MASTERDATA_MATERIAL":
        return Object.assign({}, state, {
          MASTERDATA_MATERIAL: action.data
        });
      case "TP_ADD":
        return Object.assign({}, state, {
          TP_Add: action.data
        });
      case "TPEDIT_DOCS":
        return Object.assign({}, state, {
          getedittp: action.data
        });
  
      case "SHARE_TPDATAS":
        return Object.assign({}, state, {
          sharedtpdata: action.data
        });
        
      case "ERROR_TPDATAS":
        return Object.assign({}, state, {
          errortppass: action.data
        });
      default:
        return state;
    }
  };
  
  export default TrainingPlanReducer;
  
  